module.exports = __webpack_public_path__ + "img/cancel-circle.148adf93.svg";